import { GameStateTypes } from '@gameday/utils/config/GameStateTypes';
const { LIVE, PREVIEW, FINAL } = GameStateTypes;

const getBadgeLabel = (options) => {
    const {
        abstractGameState,
        isPreGameDelay,
        isSuspended,
        isInGameDelay,
        isInstantReplay,
        isManagerChallenge,
        isUmpireReview,
        isPostponed,
        isCancelled,
        isSuspendedResumptionOnDate
    } = options;

    const content = {
        text: '',
        dictkey: '',
        type: 'default'
    };

    switch (abstractGameState) {
        case PREVIEW:
            if (isPreGameDelay) {
                content.text = 'Delayed';
                content.dictkey = 'game_status_delayed';
            }
            return content;
        case LIVE:
            content.type = 'live';
            if (isSuspended || isSuspendedResumptionOnDate) {
                content.text = 'SUSP';
            } else if (isInGameDelay) {
                content.text = 'Delay';
                content.dictkey = 'game_status_delayed';
            } else if (isInstantReplay) {
                content.text = 'Replay';
                content.dictkey = 'game_status_replay';
            } else if (isManagerChallenge) {
                content.text = 'Challenge';
                content.dictkey = 'game_status_manager_challenge_short';
            } else if (isUmpireReview) {
                content.text = 'Review';
                content.dictkey = 'game_status_umpire_review_short';
            } else {
                content.text = 'Live';
            }

            return content;

        case FINAL:
            if (isCancelled) {
                content.text = 'Cancelled';
                content.dictkey = 'game_status_cancelled';
            } else if (isPostponed) {
                content.text = 'PPD';
            } else {
                content.text = FINAL;
                content.dictkey = 'game_status_final';
            }
            return content;
        default:
            return content;
    }
};

export default getBadgeLabel;
